module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step2-pict02-full-b45a67851b4bec4b4d6e9b4b2ae2dcb2.jpg";